export const WINDOW_SCREEN_WIDTH_SM = 768;
export const WINDOW_SCREEN_WIDTH_MD = 1024;

export const MERGED_DATASETS_TITLE_SEPARATOR = "|";
